import { render, staticRenderFns } from "./provincialinfo.vue?vue&type=template&id=6b16b528&"
import script from "./provincialinfo.vue?vue&type=script&lang=js&"
export * from "./provincialinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports